import {game_session} from './api/entities';
import Constants from "../constants/constants";
import {httpGet, httpPost} from "./api/axios_api";


export const SESSION_TYPES = {
    OUT_OF_GYM: 1,
    HOME_PLAY: 2
};

export const actions = {
    resetGameSessionState: "RESET_GAME_SESSION_STATE",
    createGameSession: "CREATE_GAME_SESSION",
    updateGameSession: "UPDATE_GAME_SESSION",
    listGameSession: "LIST_GAME_SESSION",
    getGameSession: "GET_GAME_SESSION"
};


export async function getPlayerHomeSessions(playerID, token) {
    let url = `${Constants.BACKEND_URL}/get-player-home-sessions/` + playerID;
    return httpGet(url, {}, token);
}


export async function assignPlayerToSession(playerID, gameSessionID, token) {

    let params = {
        "player_id": playerID,
        "game_session_id": gameSessionID
    };

    let config = {
        params: params
    };

    let url = `${Constants.BACKEND_URL}/assign-player-to-session`;
    return httpPost(url, config, token); 
}


export async function getSessionOutOfGymStatus(playerID, gameSessionID, sessionType) {
    if (typeof sessionType === "undefined") {
        sessionType = SESSION_TYPES.OUT_OF_GYM;
    }
    let url = `${Constants.BACKEND_URL}/get-session-out-of-gym-status/${playerID}/${gameSessionID}/${sessionType}`;
    
    let token = localStorage.getItem("timocco.auth");

    return httpGet(url, {}, token); 
}

export async function updateSessionOutOfGymStatus(playerID, gameSessionID, sessionType, newStatus) {
    if (typeof sessionType === "undefined") {
        sessionType = SESSION_TYPES.OUT_OF_GYM;
    }
    let token = localStorage.getItem("timocco.auth");
    
    let params = {
        "player_id": playerID,
        "game_session_id": gameSessionID,
        "session_type": sessionType
    };

    if (typeof newStatus !== "undefined") {
        params['new_status'] = newStatus;
    }

    let config = {
        params: params
    };

   

    let url = `${Constants.BACKEND_URL}/update-session-out-of-gym-status`;
    return httpPost(url, config, token); 
}

export async function unassignPlayerFromSession(playerID, gameSessionID, token) {

    let params = {
        "player_id": playerID,
        "game_session_id": gameSessionID
    };

    let config = {
        params: params
    };

    let url = `${Constants.BACKEND_URL}/unassign-player-from-session`;
    return httpPost(url, config, token); 
}


export async function getGameSessionActivitiesAsync(gameSessionID, token) {
    let url = `${Constants.BACKEND_URL}/get-game-session-activities/${gameSessionID}`;
    return httpGet(url, {}, token); 
}

export async function getGamesForSessionDesigner(token) {
    let url = `${Constants.BACKEND_URL}/get-games-for-session-designer`;
    return httpGet(url, {}, token); 
}

export async function getTherapistGameSessionBank(token) {
    let url = `${Constants.BACKEND_URL}/get-therapist-game-sessions-bank`;
    return httpGet(url, {}, token); 
}


export function resetGameSessionState() {
    return {type: actions.resetGameSessionState}
}

export function createGameSession(gameSessionObject) {
    return game_session.create(actions.createGameSession, gameSessionObject, []);
}

export function updateGameSession(gameSessionId, gameSessionObject) {
    return game_session.update(actions.updateGameSession, gameSessionId, gameSessionObject, []);
}

export function getGameSessions(query, sort) {
    return game_session.list(actions.listGameSession, query, sort);
}

export function getGameSession(gameSessionId) {
    return game_session.get(actions.getGameSession, gameSessionId, []);
}

const INITIAL_STATE = {
    game_sessions: [],
    game_session: {}
};

export default function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case actions.resetGameSessionState:
            return {
                ...INITIAL_STATE
            };
        case actions.createGameSession:
            return {
                ...state,
                game_sessions: action.body ? [...state.game_sessions, action.body] : state.game_sessions
            };
        case actions.listGameSession:
            return {
                ...state,
                game_sessions: action.body ? action.body._items : state.game_sessions
            };
        case actions.getGameSession:
            return {
                ...state,
                game_session: action.body ? action.body : state.game_session
            };
        case actions.updateGameSession:
            return {
                ...state,
                id: action.body ? action.body : null
            };
        default:
            return {
                ...state
            };
    }
}


// WEBPACK FOOTER //
// ./src/modules/game_session.js